<script setup>
import { computed } from 'vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { resolveListingCtas } from 'dashboard/composables/lais/useListingCtas';

const props = defineProps({
  listing: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['action']);

const ctas = computed(() => resolveListingCtas(props.listing));
</script>

<template>
  <div class="grid gap-2">
    <LaisPrimaryButton
      v-for="cta in ctas"
      :key="`${cta.slot}-${cta.action}`"
      class="w-full"
      :variant="cta.variant"
      :icon="cta.icon"
      @click="emit('action', cta)"
    >
      {{ cta.label }}
    </LaisPrimaryButton>
  </div>
</template>
